document.getElementById("bars-icon").addEventListener("click", e =>{
    document.querySelector("aside").classList.toggle("show")
    document.querySelector(".overlay-bg").classList.toggle("show")
})


document.querySelector(".overlay-bg").addEventListener("click", e =>{
    document.querySelector("aside").classList.remove("show")
    document.querySelector(".overlay-bg").classList.remove("show")
})